export default "__VITE_ASSET__Bk7bwG9k__"